import { atom } from "jotai";

// If you want to pop up the edit modal for a node, set this atom to the node id
export const editingNodeAtom = atom<string | null>(null);
editingNodeAtom.debugLabel = "editingNodeAtom";
